import MicroModal from 'micromodal';
import { component } from 'picoapp';

export default component( (node) => {

  const listId = node.getAttribute('data-list-id');
  const successMessage = node.querySelector('.js-message');
  const showOncePerSession = true;
  const delay = node.getAttribute('data-delay');
  const cookieExpirationDays = node.getAttribute('data-expiration');
  var shown = false;

  const config = {
    disableScroll: true
  };

  const createCookie = (name, value, days, sessionOnly) => {
    var expires = "";

    if(sessionOnly)
      expires = "; expires=0";
    else if(days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    }

    document.cookie = name + "=" + value + expires + "; path=/";
  };

  const eraseCookie = (name) => {
    createCookie(name, "", -1);
  };

  const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");

    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  };

  const checkCookie = () => {
    if(cookieExpirationDays <= 0) {
      if(showOncePerSession && getCookie("bb_exit_nag") == "true") return true;

      eraseCookie("bb_exit_nag_shown");
      return false;
    }

    if (getCookie("bb_exit_nag_shown") == "true") return true;

    return false;
  };

  const showExitNag = () => {
    if(shown) return;
    const nagEl = document.getElementById('exitNag');
    MicroModal.show('exitNag', config);

    shown = true;

    createCookie("bb_exit_nag_shown", "true", cookieExpirationDays, false);
    createCookie("bb_exit_nag", "true", 0, true);
  };

  window.addEventListener('mouseout', (evt) => {
    if (evt.target.tagName.toLowerCase() === "input") return;
    if (evt.target.tagName.toLowerCase() === "select") return;

    if (evt.toElement == null && evt.relatedTarget == null ) {
      if (!checkCookie()) { setTimeout(showExitNag, delay); }
    }
  });

  // node.addEventListener('submit', evt => {
  //   evt.preventDefault();
  //
  //   const email = evt.target.elements.email.value;
  //
  //   if (!email) return;
  //
  //   subscribe(listId, email, {}).then(res => {
  //     successMessage.classList.remove('is-hidden');
  //     setTimeout(() => {
  //       successMessage.classList.remove('is-hidden');
  //     }, 2000);
  //   });
  // });

});
